import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import Viewer from "./files/viewer";

function PodRouter(props) {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/" element={<Viewer uuid={props.uuid} />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
